var map = {
	"./banhanguytin/6.png": "aeb1",
	"./cacung/6.png": "3365",
	"./chuyencan/6.png": "8dea",
	"./daigiadataha/6.png": "3516",
	"./duhanhgia/6.png": "7231"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4609";